const videoEnhancer = {
  HitPawOnlineAIVideoEnhance: 'HitPaw Online AI Video Enhance',
  ProcessingLimit: '處理上限：{{num}}',
  AllModelsAreAvailable: '所有模型都可使用',
  SupportAllSubdivisionRateExport: '支援匯出所有解析度',
  SupportPreviewVideo: '支援預覽影片',
  BatchProcessingComingSoon: '批量處理（即將推出）',
  CancelAnytime: '隨時取消訂閱',
  highPriorityProcessingSpeed: '高優先處理速度',
  YearDayPrice: 'NT$14.22',
  YearTotalPrice: 'NT$5190.00',
  MonthTotalPrice: 'NT$690.00',
  MonthDayPrice: 'NT$23.00',
  WeekTotalPrice: 'NT$290.00',
  WeekDayPrice: 'NT$41.43',
  Day: 'Day',
  Monthly: 'Monthly',
  Weekly: 'Weekly',
  Yearly: 'Yearly',
};

export default videoEnhancer;
